import { render, staticRenderFns } from "./ShareScatterWx.vue?vue&type=template&id=311a2c8b&scoped=true&lang=html"
import script from "./ShareScatterWx.vue?vue&type=script&lang=js"
export * from "./ShareScatterWx.vue?vue&type=script&lang=js"
import style0 from "./ShareScatterWx.vue?vue&type=style&index=0&id=311a2c8b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311a2c8b",
  null
  
)

export default component.exports